import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import usePlayer from '@fec/frontend-aron/foundation/hooks/usePlayer';

import './ModalVideo.scss';

const ModalVideo = ({ urn, frontendId, playerA11yLabel = '' }) => {
  const [isInitialized, setIsInitialized] = useState(false);
  const playerContainerRef = useRef(null);
  usePlayer({
    urn,
    frontendId,
    containerRef: playerContainerRef,
    initialize: isInitialized,
    playerFocus: true,
    playerA11yLabel: playerA11yLabel,
  });

  useEffect(() => {
    if (playerContainerRef.current) {
      setIsInitialized(true);
    }
  }, [playerContainerRef?.current]);

  return (
    <div className="modal-video">
      <div
        className="modal-video__player-container"
        ref={playerContainerRef}></div>
    </div>
  );
};

ModalVideo.propTypes = {
  urn: PropTypes.string.isRequired,
  frontendId: PropTypes.string.isRequired,
  playerA11yLabel: PropTypes.string,
};

export default ModalVideo;
